module.exports = __webpack_public_path__ + "img/prod.35edaca9.jpg";